<template>
    <section v-if="open" :class="`c-message c-message--${type} ${ customClass ? customClass : ''}`">
        <svgicon class="c-message__icon" :name="icon" :width="iconWidth" :height="iconHeight"></svgicon>
        <div class="[ c-message__text ]"><slot></slot></div>
        <button class="[ c-message__close c-button c-button--reset c-button--icon-only ]" @click="closeMessage" title="Sluiten">
            <svgicon name="close" width="21" height="21"></svgicon>
        </button>
    </section>
</template>

<script>
    export default {
        methods: {
            closeMessage() {
                this.open = false;
            }
        },
        data() {
            return {
                open: true
            }
        },
        props: ['type', 'icon', 'icon-width', 'icon-height', 'custom-class']
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

    .c-message {
        padding: em($global-spacing-unit-small) em($global-spacing-unit);
        display: flex;
        align-items: center;
        background-color: palette(color-neutral, x-light);

        > *{
            &:not(:last-child){
                margin-right: em($global-spacing-unit);
            }
        }

        &--info{
            background-color: palette(color-info, x-light);


            .c-message__close{
                color: palette(color-info, dark);
                &:hover,&:focus{
                    color: $color-info;
                }
            }
        }

        &--error{
            background-color: palette(color-error, base);
            color: $color-white;


            .c-message__close{
                color: $color-white;
                &:hover,&:focus{
                    opacity: 0.8;
                }
            }
        }
    }

    .c-message__close {
        margin-left: auto;
        padding: 0;
        width: 50px;
        height: 50px;

        &:hover{
            color: $color-alpha;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Message.vue